//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import page from '~/plugins/mixins/page';
import mentoren from '~/graphql/queries/mentoren.gql';
import startMentoring from '~/graphql/mutations/startMentoring.gql';

export default {
  auth: false,
  mixins: [page],
  apollo: {
    mentoren: {
      query: mentoren,
    },
  },
  data: () => ({
    mentoren: [],
    justBecomeMentor: false,
    filesData: [
      {
        key: 'mentoringovereenkomst',
        name: 'Mentoringovereenkomst',
      },
      {
        key: 'mentoring_traject_verantwoordingsformulier',
        name: 'Mentoring traject verantwoordingsformulier',
      },
      {
        key: 'nascholingsrichtlijnen_mentoring',
        name: 'Nascholingsrichtlijnen mentoring',
      },
    ],
  }),
  methods: {
    async becomeMentor() {
      if (confirm('Weet je zeker dat je mentor wilt worden?')) {
        try {
          await this.$apollo.mutate({
            mutation: startMentoring,
          });
          this.$toast.success('Je bent succesvol een mentor geworden');
          this.justBecomeMentor = true;
        } catch (e) {
          this.$toast.error(e);
        }
      }
    },
  },
  head: () => ({
    title: 'Mentoring',
  }),
};
